<template>
	<div>
		<hr class="mt-3 mb-4">

		<!-- Step 3 -->
		<h4 class="mb-3">
			<div class="badge badge-danger step">
				{{ $t('donation-form.step') }} 3
			</div>
			{{ $t('donation-form.summary_section_title') }}
		</h4>

		<!-- Table donation details -->
		<table class="table table-bordered mb-4">
			<thead>
				<tr>
					<th class="align-middle th-details">
						{{ $t('donation-form.summary_details_col_header') }}
					</th>
					<th class="align-middle text-right th-quantity">
						{{ $t('donation-form.summary_quantity_col_header') }}
					</th>
					<th class="align-middle text-right th-amount">
						{{ $t('donation-form.summary_amount_col_header') }}
					</th>
				</tr>
			</thead>
			<tbody>
				<template v-for="campaign in selectedCampaigns" :key="campaign">

					<!-- Campaign -->
					<tr class="bg-light">
						<th colspan="3">
							{{ campaign }}
						</th>
					</tr>
                    <template v-for="donation in donations.filter(donation => donation.campaign === campaign)" :key="donation">
						<tr v-if="donation.amount * donation.count > 0">

							<!-- Package name -->
							<td role="gridcell" class="align-middle border-b border-gray-200">
								{{ donation.name }}
							</td>

							<!-- Package count unit quantity -->
							<td role="gridcell" class="align-middle border-b border-gray-200 text-right">
                                <template v-if="! donation.custom_amount_enabled">x {{ donation.count }}</template>
							</td>

							<!-- Amount -->
							<td role="gridcell" class="align-middle border-b border-gray-200 text-right">
								{{ vueNumberFormat(donation.amount * donation.count) }}
							</td>
						</tr>
					</template>
				</template>

				<!-- Total -->
				<tr>
					<th colspan="2" class="align-middle text-right">
						{{ $t('donation-form.total') }}
					</th>
					<th class="align-middle text-right">
						{{ vueNumberFormat(total) }}
					</th>
				</tr>
			</tbody>
		</table>

		<!-- Proceed -->
		<button type="button" class="btn btn-primary btn-block btn-lg mb-4" @click="$emit('next')">
      <template v-if="formData.mandate_enabled && formData.mandate_application_type === '01'">
        {{ $t('donation-form.proceed_to_emandate_enrollment') }}
      </template>

      <template v-else-if="formData.mandate_enabled && formData.mandate_application_type === '02'">
        {{ $t('donation-form.proceed_to_emandate_maintenance') }}
      </template>

      <template v-else-if="formData.mandate_enabled && formData.mandate_application_type === '03'">
        {{ $t('donation-form.proceed_to_emandate_termination') }}
      </template>

      <template v-else>
        {{ $t('donation-form.proceed_to_donation') }}
      </template>

			<i class="fad fa-angle-double-right ml-1"></i>
		</button>
	</div>
</template>

<script setup>
	import {computed} from "vue";
  import useHelpers from "@/Composables/UseHelpers";

  const { $t } = useHelpers();

  const props = defineProps({
    formData: Object,
		selectedCampaigns: {
			type: Array
		},
		donations: {
			type: Array
		},
	});

	const total = computed(() => {
		return props.donations.map(donation => donation.amount * donation.count).reduce((prev, next) => prev + next, 0.00)
	});
</script>
